import React from 'react';
import classNames from 'classnames';
import Plan from '../plan';
import PlanLabel from '../plan-label';
import noop from '../../../../utils/noop';
import { DESKTOP_PLAN_PROPTYPES } from './constants';

const defaultCaptions = {};

const PlanDesktop = ({
  captions = defaultCaptions,
  highlighted = false,
  disabled = false,
  isLoading = false,
  onPlanSelect = noop,
  type,
  withExtraPrice = false,
}) => {
  const { label } = captions;
  const classes = classNames('ws-ui-plan-desktop', {
    'ws-ui-plan-desktop--highlighted': highlighted,
    'ws-ui-plan-desktop--disabled': disabled,
  });

  return (
    <div className={classes}>
      <div className="ws-ui-plan-desktop__content">
        <PlanLabel highlighted={highlighted} label={label} />
        <Plan
          captions={captions}
          onPlanSelect={onPlanSelect}
          isLoading={isLoading}
          disabled={disabled}
          highlighted={highlighted}
          type={type}
          withExtraPrice={withExtraPrice}
        />
      </div>
    </div>
  );
};

PlanDesktop.propTypes = DESKTOP_PLAN_PROPTYPES;

export default PlanDesktop;
